<tgrid-page-header></tgrid-page-header>

@for (reportGroup of reportGroups(); track reportGroup.id) {
  <div class="section-header">
    <vulcan-icon size="42px" [icon]="reportGroup.iconUrl" [weight]="reportGroup.iconWeight"></vulcan-icon>
    <span>{{ reportGroup.displayName }} Reports</span>
  </div>

  <div class="section-subtitle">
    {{ reportGroup.description |  sanitize }}
  </div>

  <div class="section-content">
    <div class="content-info">

      <div class="info-card-container">
        @for (report of reportGroup.reports; track $index) {
          <div class="info-card">
            <vulcan-icon size="32px" icon="folders" weight="fill"></vulcan-icon>
            <span>{{ report.displayName }}</span>
            <p [innerHTML]="report.description | sanitize"></p>
            <button mat-flat-button color="primary" [routerLink]="report.serviceUrl">
              Run Reports
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
<tgrid-page-footer></tgrid-page-footer>
